import styled from 'styled-components';
import Image from '../../common/Image/Image';

export const GoTriberBannerWrapper = styled.div(
  props => `
    display: flex;
    width: 100%;
    margin-bottom:${props.theme.spacing.base};
    margin-top:${props.theme.spacing.base};
  `,
);

export const GoTriberBannerImage = styled(Image)(
  props => `
    width: 100%;
    position: relative;
    height: 8.2rem;
  `,
);

export const MainContent = styled.div(
  props => `
      display:flex;
      position: absolute;
      text-align: center;
      margin-top: 1rem;
      // margin-left: 1.5rem;
    `,
);

export const GoTribeLeftBlockDiv = styled.div(
  props => `
    display:flex;
    flex-direction:column;
    padding-left:${props.theme.spacing.base};
    padding-top:${props.theme.spacing.base};
`,
);

export const GoTribeTextBlockDiv = styled.div(
  props => `
      display:flex;
      width:55%;
      flex-direction:column;
      padding: 0 10px;
    `,
);

export const GoTribeBoldTextSpan = styled.span(
  props => `
      font-size:${props.theme.font.custom(14)};
      padding-bottom:${props.theme.spacing.base};
      color: ${props.textColor || ''}
      background-color: ${props.bgColor || ''}

    `,
);
